<template>
  <div xs12>
    <v-container fluid xs12 v-if="artist_artworks(artist.id).length > 0" class="py-0 mt-0 mb-3 pl-0 pr-0" >
      <v-layout class="xs12 mx-0 px-0 my-0 row wrap">
        <v-flex xs12 mt-3 v-for="(item, index) in artist_artworks(artist.id)" :key="index">

          <!-- <div v-if="item.header" :key="item.header">{{ item.header }}</div>
          <div v-else-if="item.divider" :inset="item.inset" :key="index"></div>
          <div v-else :key="item.id">{{item.key}} -->
            <!-- <v-list-tile-avatar> -->
            <!-- <v-list-tile-action style="width:150px; text-align:center;" class="my-0 mx-0 px-0 text-xs-center align-center justify-center">
              <img v-if="item.top_photo_id>0"
                v-bind:src="'http://tb-cms.org/data/artwork/' + item.id + '/' + item.top_photo_id + '_th.jpg'" 
              />
            </v-list-tile-action>   -->
            <!-- </v-list-tile-avatar> -->
            <!-- <div class="ml-1 pl-1"> -->
              <v-layout  class="justify-end row fill-height/">
                <!-- <v-flex style="width:40px;" class="text-xs-left align-start">
                  <v-checkbox class="mt-3 mb-0 pb-0 mr-3 pr-0" color='black'></v-checkbox>
                </v-flex> -->
                <v-flex class="shrink ml-0 pl-0 subheading justify-start text-truncate font-weight-light">
                  <router-link :to="{ name: 'EditArtwork', params: {id: item.id, artwork: item}, path: `/artworks/edit/${item.id}`}" class="link">
                    <!-- <v-icon class="mr=2 " small>edit</v-icon>  -->
                    <b>{{item.title}} </b><v-icon small color="black" style="padding-bottom:2px; padding-left:4px;">open_in_new</v-icon>
                  </router-link> 
                  <!-- <router-link :to="{ name: 'ViewArtwork', params: {id: item.id, artwork: item}, path: `/artworks/view/${item.id}`}" >
                    {{ item.title }}
                  </router-link> -->
                  <div style="line-height: 2em; border-top: 1px solid black; margin-top: 5px;">
                    {{item.accession_number}} - {{ getOwnershipName(item.ownership) }}<br/>
                    <!-- {{item.credit}} , {{item.classification}}-->
                  </div>
                </v-flex>

                <v-flex grow text-xs-right ml-4>
                  <v-menu v-if="get_texts(item.id).length > 0" offset-y :close-on-content-click="false" :nudge-width="0" class="elevation-0" bottom left>
                    <template slot="activator">
                      <v-btn small icon color="black" class="mt-2">
                        <v-icon small color="white">mdi-text-subject</v-icon> 
                      </v-btn>
                    </template>
                    <v-list class="px-0" one-line elevation-0>
                      <v-list-tile class="my-0 py-0" v-for="text in get_texts(item.id)" :key="text.id" @click="download_text(text,item)" >
                        <v-btn small icon color="black" >
                          <v-icon small color="white">mdi-download</v-icon> 
                        </v-btn>
                        {{text.title}}
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-flex>
              </v-layout>
            <!-- </div> -->
          <!-- </div> -->

        </v-flex>

      </v-layout>
    </v-container>

    <div v-else class="align-items-start justify-start flex">
      <span class="my-0 body-1 py-0 mx-0 px-1 text-xs-left flex align-start justify-start">No Artworks</span>
    </div>

  </div>
</template>

<script>
  export default {
    data () {
      return {
        // showMore: false,
        ownerships: this.$store.getters.my_ownerships,
      }
    },
    props:['artist'],
    methods: {
      getOwnershipName (ao) {
        // console.log(ao)
        var aoo = this.ownerships.find(o => o.id == ao)
        if (aoo){
          return aoo.name
        } else {
          return 'Not Set'
        }
      },
      download_text (text,item){
        this.exportHTML(text,item)
      },
      get_texts(artwork_id) {
        var a = Object.assign([],this.$store.state.texts)
        // console.log('artwork_id')
        // console.log(artwork_id)
        // console.log(a.artist_id == artist_id)
        var aa = a.filter(a => {
          return a.artwork_id === artwork_id}
        )
        return aa
      },
      artist_artworks (artist_id) {
        var a = Object.assign([],this.$store.state.artworks)
        // console.log('artist_id')
        // console.log(artist_id)
        // console.log(a.artist_id == artist_id)
        var aa = a.filter(a => {
          // console.log('a.artist_id')
          // console.log(a.artist_id)
          // console.log(artist_id)
          return a.artist_id === artist_id}
        )
        // console.log(aa)
        return aa
      },
      clear_selection () {
        this.$store.dispatch('clearCurrentSelection')
        this.selected = []
      },
      select_all () {
      },
      save_currently_selected(a,b) {
        // console.log('///////////')
        // console.log('a = ' + a)
        // console.log('b = ' + b.id)
        setTimeout(function () {
          var temp_selection = Object.assign([], this.$store.state.currentSelection)
          //// console.log(temp_selection)
          if (!a) {
            // console.log('a true')
            if (!temp_selection.includes(b)) {
              // console.log('doesnt include')
              temp_selection.push(b)
            }
          } else {
            // console.log('false')
            var index = temp_selection.indexOf(b);
            // console.log('index = ' + index)
            temp_selection.splice(index,1)
          }
          // this.$store.state.currentSelection
          // console.log(temp_selection)
          // this.selected.forEach(s => {
          //   if (!temp_selection.includes(s)) {
          //     temp_selection.push(s)
          //   }
          // })
          // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
          this.$store.dispatch('saveCurrentSelection',temp_selection)
        }.bind(this),1000)
      },
      save_currently_selected_all(a) {
        // console.log('///////////')
        // console.log('a = ' + a)
        var temp_selection = Object.assign([], this.$store.state.currentSelection)
        // console.log(temp_selection)
        if (!a) {
          // console.log('a true')
          if (!temp_selection.includes(b)) {
            // console.log('doesnt include')
            temp_selection.push(b)
          }
        } else {
          // console.log('false')
          var index = temp_selection.indexOf(b);
          // console.log('index = ' + index)
          temp_selection.splice(index,1)
        }
        // this.$store.state.currentSelection
        // console.log(temp_selection)
        // this.selected.forEach(s => {
        //   if (!temp_selection.includes(s)) {
        //     temp_selection.push(s)
        //   }
        // })
        // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
        this.$store.dispatch('saveCurrentSelection',temp_selection)
      },
      save_currently_selected_tags() {
        this.$store.dispatch('saveCurrentSelectionTags',this.selected_tags)
        this.ta = this.tagged_artworks
      }      
    }
  }
</script>

<style scoped>
  a i {
    opacity: 0;
  }
  a:hover i {
    opacity: 1;
  }
  /* a {text-decoration: none; line-height: 1.5em;border-bottom: 1px solid #000; padding-bottom: 4px;} */
  /* a:hover {text-decoration: underline;} */
</style>


// WEBPACK FOOTER //
// src/components/artists/ViewArtworks.vue